import { useEffect, useState } from 'react';
import { BaseSelector } from '../../../domain/shared';
import { citiesRepository } from '../../../infrastructure/repositories/geography/cities/cityRepository';
import Select from 'react-select';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined | null;
    name: string;
}

export default function CitySelector({ onChange, value, name }: Props) {
    const [cities, setCities] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        citiesRepository.GetCitiesList().then((res) => {
            setIsLoading(false);
            setCities(
                res.map((c) => ({
                    label: c.name,
                    value: c.id,
                }))
            );
        });
    }, []);

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                Ciudad *
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                name='color'
                options={cities}
                onChange={(c) => {
                    onChange(name, c?.value);
                }}
                value={
                    cities.find((c) => c.value === value) ?? {
                        label: 'Seleccione',
                        value: 0,
                    }
                }
            />
        </div>
    );
}
